
import "./Header.scss"

const Header = () => {
  return (
    <div className="header">
    <h1> WHO ARE YOU?</h1>
    </div>
  );
};

export default Header;
